import React from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";

// Hook
import { useAuth } from "../hooks/useAuth";

// Components
import { BlueButton } from "../components/Buttons";
import { FormInput } from "../components/FormInput";
import MainView from "../components/MainView";

// Helpers
import { checkAuth, handleSignIn } from "../helpers/authHelper";
import { validateSignIn } from "../helpers/formHelper";

export default function SignIn() {
  const navigate = useNavigate();

  const { auth, setAuth } = useAuth();

  const { refresh_token_expired } = checkAuth(auth.token);

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const clearForm = () => {
    setEmail("");
    setPassword("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let payload = {
      email,
      password,
    };

    let isValid = validateSignIn(payload);

    if (isValid) {
      // Handle sign in
      handleSignIn(payload, navigate, clearForm, setAuth);
    }
  };

  // Check Auth State and Redirect to Games Page if Authenticated
  return !refresh_token_expired ? (
    <Navigate to="/games" replace />
  ) : (
    <MainView>
      <div className="pt-5 px-[5vw] 2xl:px-[15vw]">
        <div className="mb-5">
          <form id="signinForm" onSubmit={(e) => handleSubmit(e)}>
            <div className="flex flex-col">
              <div className="mb-3 w-full sm:w-[60%] md:w-[40%] mx-auto">
                <FormInput
                  label="Email"
                  type="text"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="mb-3 w-full sm:w-[60%] md:w-[40%] mx-auto">
                <FormInput
                  label="Password"
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div className="mb-3 w-full sm:w-[60%] md:w-[40%] mx-auto">
                <p className="w-full font-retro-rounded font-medium text-xl">
                  <Link to="/reset" className="text-retro-blue">
                    have you forgotten your password?
                  </Link>
                </p>
              </div>

              <div className="mt-7 mb-4 w-full sm:w-[40%] md:w-[40%] mx-auto">
                <BlueButton type="submit">Sign In</BlueButton>
              </div>
            </div>
          </form>
        </div>
      </div>
    </MainView>
  );
}
